import React from "react";
import ITextOptions from "../../../../model/interface/form/elementOptions/ITextOptions";
import {Typography} from "antd";
import Utils from "../../../../utils";
import IWidgetProps from "../../../../model/interface/widget/IWidgetProps";
import IWidgetPropsFunctions from "../../../../model/interface/widget/IWidgetPropsFunctions";
import settingsService from "../../../../model/service/SettingsService";
import LocaleText from "../../settings/dictionary/LocaleText";
import {IAppState} from "../../../../redux/store";
import selectors from "../../../../redux/selectors";
import {connect} from "react-redux";

interface IProps extends IWidgetProps<IWidgetPropsFunctions, ITextOptions> {
    getText: (code: string, fallBack?: string) => string
}

class TextWidget extends React.Component<IProps> {

    renderText = (options: ITextOptions) => {
        const styles = options.style && !Utils.isNull(options.style) ?
            options.style.reduce((a, v) => ({...a, [v]: true}), {}) : {}
        const params = {
            ...styles, style: {color: options.color},
            ellipsis: Utils.toBoolean(options.ellipsis),
            level: Number(options.titleLevel ? options.titleLevel : 1) as ITextOptions["titleLevel"]
        }
        const {getText}  = this.props

        return (
            <div>
                {Utils.toBoolean(options.wysiwyg) ? (
                        <div className={"ant-typography"} key={getText(options.text)} dangerouslySetInnerHTML={{__html: (getText(options.text))}}/>)
                    :
                    Utils.toBoolean(options.isTitle) ? (
                        <Typography.Title {...params} style={{color: settingsService.getThemeColor()}}>
                            <LocaleText code={options.text}/>
                        </Typography.Title>
                    ) : Utils.toBoolean(options.copyable) ? (
                        <Typography.Paragraph copyable={true} {...params}><LocaleText code={options.text}/></Typography.Paragraph>
                    ) : (
                        <Typography.Text {...params}><LocaleText code={options.text}/></Typography.Text>
                    )
                }
            </div>
        )
    }

    render() {
        const {options} = this.props

        return (
            <>
                {this.renderText(options)}
            </>
        );
    }
}

const mapStateToProps = (state: IAppState) => {

    return {
        getText: (code: string, fallback?: string) => selectors.dictionary.getMessage(state, code, fallback)
    }
}

export default connect(mapStateToProps)(TextWidget)